import React from 'react';
import { useState } from 'react';
import {Link} from 'react-router-dom';
import GoogleFontLoader from 'react-google-font-loader';
import './App.css';


import {  
  Collapse, Navbar, NavbarToggler, Nav, NavItem, NavbarText
} from 'reactstrap';


function Navigation() {

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (

    <div>
    {/* GOOGLE FONTS -------------------------------------------------------------*/}       
    <GoogleFontLoader
    fonts={[
        {
          font: 'Poppins',
          weights: [400, 700],
        },
    ]}
    subsets={['cyrillic-ext', 'greek']}
     />

   


    <Navbar dark style={{backgroundColor:'#282828'}}>

    <NavbarText style={{
    color:'white', 
    fontFamily:'Impact', 
    fontSize:'30px',
    marginLeft:'20px'
    }}><Link to="/" style={{color:'white'}}><h1 style={{color:'white', fontFamily:'Poppins', 
                    fontSize:'30px', fontWeight:'bold'}}>Caroline Zaini</h1></Link></NavbarText>

      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="mr-auto" navbar style={{marginLeft:'20px'}}>

        <NavItem >
            <Link to="/" style={{color:'white'}}>Accueil</Link>
          </NavItem>

          <NavItem>
            <Link to="/formations" style={{color:'white'}}>CV</Link>
          </NavItem>

          <NavItem>
            <Link to="/productions" style={{color:'white'}}>Mes applications</Link>
          </NavItem>

          <NavItem>
            <Link to="/architecture" style={{color:'white'}}>Autres créations</Link>
          </NavItem>

          <NavItem>
            <Link to="/contact" style={{color:'white'}}>Contact</Link>
          </NavItem>
         
        
        </Nav>
    
      </Collapse>
    </Navbar>


    </div>










  // <div>
  // <Navbar color="faded" dark style={{backgroundColor:'#282828'}}>
  //   <NavbarBrand href="/" className="mr-auto" style={{
  //   color:'white', 
  //   fontFamily:'Impact', 
  //   fontSize:'30px',
  //   marginLeft:'20px'
  //   }}>Caroline Zaini</NavbarBrand>
    
  
 
  //     <Nav navbar>

  //     <NavItem style={{marginLeft:'20px'}}>
  //         <Link href="/" style={{color:'#9b9b9b'}}>Accueil</Link>
  //       </NavItem>
  //       <NavItem style={{marginLeft:'20px'}}>
  //         <Link href="/productions" style={{color:'#9b9b9b'}}>Réalisations</Link>
  //       </NavItem>
  //       <NavItem style={{marginLeft:'20px'}}>
  //         <Link href="/formations" style={{color:'#9b9b9b'}}>CV</Link>
  //       </NavItem>
  //       <NavItem style={{marginLeft:'20px'}}>
  //         <Link href="https://github.com/MadameZ?tab=repositories" style={{color:'#9b9b9b'}}>GitHub</Link>
  //       </NavItem>
  //       <NavItem style={{marginLeft:'20px'}}>
  //         <Link href="/contact" style={{color:'#9b9b9b'}}>Contact</Link>
  //       </NavItem>

  //     </Nav>

  // </Navbar>
  // </div>




);
}

export default Navigation;
